import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Input, message } from 'antd';
import { TbFormItem, TbButton } from '../TaobaoPage/components';
import { getShortUrl } from '../../api/shortUrl';
import useStatistic, { useClickStatistic } from '../TaobaoPage/hooks/useStatistic';
import './style.less';

const clsPrefix = 'p-short-url';

message.config({
  top: 50,
  duration: 3,
  maxCount: 3,
});

const ShortURLContainer:React.FC<{}> = () => {
  const [ originalUrl, setOriginalUrl ] = useState<string>();
  const [ generatedUrl, setGeneratedUrl ] = useState<string>('');
  const [ isLoading, setIsLoading ] = useState(false);

  // useStatistic('taobaoke-short-url');

  function handleClear() {
    setOriginalUrl('');
    setGeneratedUrl('');
  }

  function GeneratingCheck(url: string) {
    // 检查url是否带有协议
    if (!url.startsWith('https') && !url.startsWith('http')) {
      message.info('输入的网址需要以http或者https开头');
      return false;
    }

    return true;
  }

  function handleGenerate() {
    // useClickStatistic('short-url-generate', 'short-url-generate-button');

    if (!GeneratingCheck(originalUrl)) {
      return;
    }

    setIsLoading(true);
    // @ts-ignore
    getShortUrl(originalUrl).then((data: { shortUrl?: string }) => {
      setGeneratedUrl(data && data.shortUrl)
      setIsLoading(false);
    }).catch((errMsg?: string) => {
      if (typeof errMsg === 'string') {
        message.error(errMsg);
      } else {
        message.error('请求异常');
      }
      setIsLoading(false);
    })
  }

  function handleUrlsInput(value?: string) {
    setOriginalUrl(value)
  }

  return (
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__content`}>
        <div className={`${clsPrefix}__title`}>短链接生成</div>
        <TbFormItem label="请输入要生成短链接的网址，需要带http或https">
          <Input
            className={`${clsPrefix}__form-item--input`}
            // rows={7}
            value={originalUrl}
            onChange={e => handleUrlsInput(e.target.value)}
          />
        </TbFormItem>
        <div className={`${clsPrefix}__buttons`}>
          <TbButton 
            loading={isLoading}
            theme="primary"
            content={isLoading ? "生成中" : "开始生成"}
            width="196px"
            onClick={handleGenerate}
            disabled={!originalUrl}
          />
          <TbButton content="清空" width="196px" onClick={handleClear} />
        </div>
        <TbFormItem label="处理结果">
          <div className={`${clsPrefix}__form-item--generated`}>
            <span style={generatedUrl.includes('domain is not support') ? {color: '#FF4D54'} : {}}>{generatedUrl}</span>
          </div>
        </TbFormItem>
        <CopyToClipboard text={generatedUrl}>
          <TbButton theme="primary" content="复制链接" width="196px" onClick={() => { message.success('复制成功') }} disabled={!generatedUrl} />
        </CopyToClipboard>  
      </div>
    </div>
  )
}

export default ShortURLContainer;